<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
	<div class="card-header">
		<div class="row">
			<div class="col">
				Pre Onboarding
			</div>
			<div class="col-auto">
				<button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary"
					[routerLink]="['/onboarding/preonboarding/preinit/',0,this.Filter.Category]"
					[disabled]="isDisabled">
					<i class="bi bi-person-plus" *ngIf="!isDisabled"></i>
					<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
						*ngIf="isDisabled"></span>
					{{!isDisabled?'Add Employee':'Loading...'}}
				</button>
				<button type="button" class="btn btn-outline-primary ms-1" [disabled]="isDisabled"
					(click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
					aria-controls="collapseExample">
					<i class="bi bi-caret-down-fill" *ngIf="!isDisabled"></i>
					<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
						*ngIf="isDisabled"></span>
					{{!isDisabled?'Filter':'Loading...'}}
				</button>
				<button type="button" class="btn btn-outline-primary ms-1" [disabled]="isDisabled"
					(click)="ESS_GetEmployeeDumpFilter()"><i class="bi bi-file-earmark-spreadsheet-fill"
						*ngIf="!isDisabled"></i>
					<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
						*ngIf="isDisabled"></span>
					{{!isDisabled?'Excel':'Loading...'}}</button>
			</div>
		</div>
	</div>
	<div class="card-body">
		<div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed" class="mt-1">
			<div class="card">
				<div class="card-body py-2">
					<div class="row my-1">
						<div class="col-md-4">
							<label for="EmployeeCode" class="text-label-dark">Employee Code</label>
							<input class="form-control" placeholder="Ex. EMP001" id="EmployeeCode" name="EmployeeCode"
								[(ngModel)]="Filter.EmployeeCode" #EmployeeCode="ngModel" maxlength="100" />
						</div>
						<div class="col-md-4">
							<label for="OldEmployeeCode" class="text-label-dark">Old Employee Code</label>
							<input class="form-control" placeholder="Ex. EMP001" id="OldEmployeeCode"
								name="OldEmployeeCode" [(ngModel)]="Filter.EmployeeOldCode" #OldEmployeeCode="ngModel"
								maxlength="100" />
						</div>
						<div class="col-md-4">
							<label for="EmpName" class="text-label-dark">Employee Name</label>
							<input class="form-control" placeholder="Ex. John Alexander" id="EmpName" name="EmpName"
								[(ngModel)]="Filter.EmpName" #EmpName="ngModel" maxlength="100" />
						</div>
					</div>
					<div class="row my-1">
						<div class="col-md-4">
							<label for="BranchName" class="text-label-dark">Branch Name</label>
							<input class="form-control" placeholder="Ex. Mumbai" id="BranchName" name="BranchName"
								[(ngModel)]="Filter.BranchName" #BranchName="ngModel" maxlength="100" />
						</div>
						<!-- <div class="col-md-4">
							<label for="Category" class="text-label-dark mb-2">Employee Type</label>
							<br />
							@for (EmployeeCategory of common.EmployeeCategorys; track EmployeeCategory.EmployeeCategory;
							let i =
							$index) {
							<label class="form-check-label link-dark px-1" ngbButtonLabel>
								<input class="form-check-input" type="radio" [value]=EmployeeCategory.Value
									name='Category' [(ngModel)]="Filter.Category" [ngModelOptions]="{standalone: true}">
								{{EmployeeCategory.EmployeeCategory}}
							</label>
							}
							<label class="form-check-label link-dark px-1" ngbButtonLabel>
								<input class="form-check-input" type="radio" [value]='' name='Category'
									[(ngModel)]="Filter.Category" [ngModelOptions]="{standalone: true}">
								Both
							</label>
						</div> -->
						<div class="col-md-8">
							<label for="CustomSelect" class="text-label-dark">Custom</label>
							<div class="input-group mb-3">
								<ng-select name="FilterColumns" [items]="FilterColumns" bindLabel="FilterName"
									bindValue="ESS_CustomSearchFilterId" [(ngModel)]="Filter.Ess_CustomSearchFilterId"
									placeholder="Select Field" style="width: 13rem;" required>
								</ng-select>
								<input class="form-control" placeholder="Ex. John Alexander" id="FilterValue"
									name="FilterValue" [(ngModel)]="Filter.FilterValue" #FilterValue="ngModel"
									maxlength="100" />
							</div>
						</div>
					</div>
				</div>
				<div class="card-footer">
					<div class="d-grid gap-2 d-md-flex justify-content-md-end">
						<button type="button" class="btn btn-primary" (click)="GetData();isCollapsed = !isCollapsed"
							[disabled]="isDisabled"><i class="bi bi-chevron-right" *ngIf="!isDisabled"></i>
							<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
								*ngIf="isDisabled"></span>
							{{!isDisabled?'Apply':'Loading...'}}</button>
					</div>
				</div>
			</div>
		</div>
		<div class="pt-2">
			<div class="row pt-2">
				<table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
					<thead class="table-light">
						<tr>
							<th [ngClass]="{'colHide': !this.common.PageRight.IsEdit && !this.common.PageRight.IsView}">
								Action</th>
							<th [ngClass]="{'colHide': !this.common.PageRight.IsDelete}">Delete</th>
							<th style="width: 300px;">Details</th>
							<th style="width: 150px">Branch</th>
							<th style="width: 100px">Old Code</th>
							<th style="width: 100px">Registration Date</th>
							<th style="width: 100px">Joining Date</th>
							<th style="width: 100px">Birth Date</th>
							<!-- <th style="width: 100px">Working Status</th> -->
							<!-- <th style="width: 50px">Employee Type</th> -->
							<th style="width: 200px"
								[ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.Category) == 'back'}">Client
							</th>
							<th style="width: 200px"
								[ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.Category) == 'back'}">Site
							</th>
							<th style="width: 100px">Rating</th>
							<th style="width: 100px">Status</th>
							<th style="width: 100px">Active</th>
							<th style="width: 100px">Approval Status</th>
							<th style="width: 100px">URLExpiry</th>
							<!-- <th>Rating</th>
						<th>Progress</th> -->
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let element of EmployeeData; let i = index">
							<td [ngClass]="{'colHide': !this.common.PageRight.IsEdit && !this.common.PageRight.IsView}"
								class="p-1">
								<div ngbDropdown class="arrow-none text-center"  container="body">
									<i class="bi bi-three-dots-vertical dropdown-toggle-none" ngbDropdownToggle></i>
									<div ngbDropdownMenu>
										<button ngbDropdownItem type="button"
											*ngIf="this.common.PageRight.IsEdit && common.ToLowerCase(element.Status) != 'not-Initiated'"
											[routerLink]="['/onboarding/preonboarding/add/' + element['EmpMasterId'] + '/' + Filter.IsDraft]"><i
												class="bi bi-pencil-square me-2"></i>Edit</button>
										<button ngbDropdownItem type="button"
											*ngIf="this.common.PageRight.IsEdit && common.ToLowerCase(element.Status) == 'not-initiated'"
											[routerLink]="['/onboarding/preonboarding/preonboardingsetup/' + element['EmpMasterId']]"><i
												class="bi bi-pencil-square me-2"></i>Edit Setup</button>
										<button ngbDropdownItem type="button" *ngIf="this.common.PageRight.IsView"
											[routerLink]="['/onboarding/preonboarding/detail/' + element['EmpMasterId'] + '/' + Filter.IsDraft]"><i
												class="bi bi-eye  me-2"></i>View</button>
									</div>
								</div>
							</td>
							<td [ngClass]="{'colHide': !this.common.PageRight.IsDelete}">
								<button class="btn btn-sm" name="delete" style="color: rgb(236, 4, 4);"
									(click)="DeleteDraft(element)"><i class="bi bi-trash-fill"></i></button>
							</td>
							<td style="width: 300px;">
								<div class="row" style="align-items: center;" style="align-items: center;width: 300px;">
									<div class="col-2">
										<img *ngIf="element['Photo'] != null && element['Photo'] != ''"
											(click)="common.FullImage('',{ProfileImage:common.PhotoLink(element['Photo']),Name:element['EmployeeName'],Code:element['EmpCode']} )"
											mat-card-image class="userImage"
											[src]="common.PhotoLink(element['Photo'])" />
										<div *ngIf="element['Photo'] == null || element['Photo'] == ''"
											(click)="common.FullImage('',{ProfileImage:common.PhotoLink(element['Photo']),Name:element['EmployeeName'],Code:element['EmpCode']} )"
											class="initial-image">
											<div class="image">
												{{common.getInitial(element['EmployeeName'])}}
											</div>
										</div>
									</div>
									<div class="col-10">
										<span class="text-label">{{element['EmployeeName']}}</span><br />
										<span class="text-label-light">#{{element['EmpCode']}} <span
												*ngIf="element['DesignationName'] != null && element['DesignationName'] != ''">[{{element['DesignationName']}}]</span></span><br />
									</div>
								</div>
							</td>
							<td style="width: 150px">
								<div style="width: 150px">{{element['BranchName']}}</div>
							</td>
							<td style="width: 100px">
								<div style="width: 100px">{{element['EmpOldCode']}}</div>
							</td>
							<td style="width: 100px">
								<div style="width: 100px">{{element['RegistrationDate']}}</div>
							</td>
							<td style="width: 100px">
								<div style="width: 100px">{{element['JoiningDate']}}</div>
							</td>
							<td style="width: 100px">
								<div style="width: 100px">{{element['BirthDate']}}</div>
							</td>
							<!-- <td style="width: 100px">
								<div style="width: 100px">{{element['WorkingStatus']}}</div>
							</td> -->
							<!-- <td style="width: 50px">
								<div style="width: 50px">{{element['EmpType']}}</div>
							</td> -->
							<td style="width: 200px"
								[ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.Category) == 'back'}">
								<div style="width: 200px">{{element['ClientName']}}</div>
							</td>
							<td style="width: 200px"
								[ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.Category) == 'back'}">
								<div style="width: 200px">{{element['SiteName']}}</div>
							</td>
							<td style="width: 100px">
								<div style="width: 100px">{{element['Rating']}}</div>
							</td>
							<td style="width: 100px">
								<div style="width: 100px">{{element['Status']}}</div>
							</td>
							<td style="width: 100px">
								<div style="width: 100px"><span class="badge"
										[ngClass]="{'success': element['Active'],'danger': !element['Active']}">
										{{element['Active']?'Active':'Deactive'}}</span></div>
							</td>
							<td style="width: 100px">
								<div style="width: 100px">{{element['ApprovalStatus']}}</div>
							</td>
							<td style="width: 100px">
								<div style="width: 100px">{{element['URLExpiryDate']}}</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</div>